import { CenteredLayout, ContentHeader, Css, useModal } from "@homebound/beam";
import { disableBasedOnPotentialOperation } from "src/routes/components/PotentialOperationsUtils";
import {
  PlanPackageElevationsV2Query,
  usePlanPackageElevationsV2Query,
} from "src/routes/libraries/plan-package-v2/components/ElevationsTab.generated";
import { ElevationCard } from "src/routes/libraries/plan-package-v2/components/elevations/ElevationCard";
import { queryResult } from "src/utils";
import { AddEditElevationModal } from "./elevations/AddEditElevationModal";

type ElevationsTabProps = { planPackageId: string; versionId: string };

export function ElevationsTab({ planPackageId, versionId }: ElevationsTabProps) {
  const query = usePlanPackageElevationsV2Query({ variables: { id: planPackageId, versionId } });
  return queryResult(query, ({ planPackage }) => <DataView planPackage={planPackage} />);
}

type DataViewProps = { planPackage: PlanPackageElevationsV2Query["planPackage"] };

function DataView({ planPackage }: DataViewProps) {
  const { openModal } = useModal();
  const disabled = disableBasedOnPotentialOperation(planPackage.canEdit);
  const elevations = planPackage.options.filter((o) => o.active && o.type.isElevation).sortBy((o) => o.order);

  return (
    <CenteredLayout size="lg">
      <ContentHeader
        title="Elevations"
        description=" Elevations are sets of exterior options that represent a particular architectural style. Exterior Schemes,
              which are styling choices within Elevations, are configured in Product Offerings."
        actions={[
          {
            label: "Add Elevation",
            icon: "plus",
            variant: "secondary",
            disabled,
            onClick: () => openModal({ size: "lg", content: <AddEditElevationModal planPackage={planPackage} /> }),
          },
        ]}
        xss={Css.px3.pt3.$}
      />
      <div css={Css.p3.df.fdc.gap3.$}>
        {elevations.isEmpty ? (
          <div css={Css.py3.tac.$}>No elevations added.</div>
        ) : (
          <div css={Css.dg.gtc("repeat(auto-fill, minmax(330px, 1fr))").gap3.$}>
            {elevations.map((e, i) => (
              <ElevationCard
                key={e.id}
                elevation={e}
                planCode={planPackage.displayCode}
                onClick={
                  disabled
                    ? undefined
                    : () =>
                        openModal({
                          size: "lg",
                          content: <AddEditElevationModal planPackage={planPackage} elevation={e} />,
                        })
                }
              />
            ))}
          </div>
        )}
      </div>
    </CenteredLayout>
  );
}
